module.exports = __webpack_public_path__ + "static/img/model2-3.0941ceda.jpg";